import * as React from 'react';

import { ErrorPopover } from '../ErrorPopover';
import { Input } from '@cian/ui-kit';

import * as styles from './styles.css';
import { IRoomNumberInputProps } from 'shared/common/utils/types';

export const RoomNumberInput: React.FC<IRoomNumberInputProps> = (props, ref) => {
  const { value, onValueChange, placeholder, errorMessage, onBlur } = props;

  return (
    <div className={styles['container']}>
      <ErrorPopover tooltipContent={errorMessage}>
        <Input
          ref={ref}
          value={value}
          onBlur={onBlur}
          onChange={e => onValueChange(e.target.value)}
          invalid={Boolean(errorMessage)}
          placeholder={placeholder || '123'}
          data-testid="room_number_input"
          size="M"
          maxLength={4}
        />
      </ErrorPopover>
    </div>
  );
};
